import { useSelector } from 'react-redux'
import { Icon } from '@iconify/react'

// slices
import { loginState } from '../../modules/login/login.slice'

// styles
import styles from './navigation.module.css'

// routes
import { PRIVATE_ROUTES } from '../../routes'
import { HomeSidebarIcon } from '../../assets/icons'
import {
    canViewClients,
    canViewMarketX,
    canViewTalent,
} from '../../helpers/reportsPermission'
// import { canAccessStoryMapMigration } from '../../modules/storyMapMigration/storyMapMigration.utils'

function SuperAdminRoutesNavigation() {
    const { status, userProfile } = useSelector(loginState)

    const profileReady = Boolean(
        status !== 'loading' && userProfile && userProfile?.isSupportUser
    )
    const canSeeClients = profileReady && canViewClients(userProfile)
    const canSeeTalent = profileReady && canViewTalent(userProfile)
    const canSeeMarketX = profileReady && canViewMarketX(userProfile)

    // const canSeeMigration = canAccessStoryMapMigration(userProfile)

    const adminNavItems = []

    if (canSeeClients) {
        adminNavItems.push({
            key: 'clients',
            route: PRIVATE_ROUTES.clients,
            label: 'Clients ',
            icon: (
                <Icon
                    icon="ph:users"
                    className={styles.icon + ' ' + styles.clientIcon}
                    width={20}
                    height={20}
                />
            ),
        })
    }

    if (canSeeTalent) {
        adminNavItems.push({
            key: 'talent',
            label: 'TalentX',
            icon: (
                <Icon
                    icon="ph:user-list"
                    className={styles.icon + ' ' + styles.clientIcon}
                    width={20}
                    height={20}
                />
            ),
            children: [
                {
                    key: 'jobs',
                    route: PRIVATE_ROUTES.jobs,
                    label: 'Jobs',
                    icon: (
                        <Icon
                            icon="mdi:briefcase-outline"
                            className={styles.icon + ' ' + styles.clientIcon}
                            width={18}
                            height={18}
                        />
                    ),
                },
                {
                    key: 'candidates',
                    route: PRIVATE_ROUTES.candidate.root,
                    label: 'Candidates',
                    icon: (
                        <Icon
                            icon="mdi:account-search-outline"
                            className={styles.icon + ' ' + styles.clientIcon}
                            width={18}
                            height={18}
                        />
                    ),
                },
                {
                    key: 'people',
                    route: `${PRIVATE_ROUTES.talent}/people`,
                    label: 'Resources',
                    icon: (
                        <Icon
                            icon="mdi:account-group-outline"
                            className={styles.icon + ' ' + styles.clientIcon}
                            width={18}
                            height={18}
                        />
                    ),
                },
            ],
        })
    }

    if (canSeeMarketX) {
        adminNavItems.push({
            key: 'marketx',
            label: 'MarketX',
            icon: (
                <Icon
                    icon="mdi:lightbulb-on-outline"
                    className={styles.icon + ' ' + styles.clientIcon}
                    width={20}
                    height={20}
                />
            ),
            children: [
                {
                    key: 'inspiration-gallery',
                    route: PRIVATE_ROUTES.inspirationGallery.root,
                    label: 'Inspiration Gallery',
                    icon: (
                        <Icon
                            icon="mdi:image-multiple-outline"
                            className={styles.icon + ' ' + styles.clientIcon}
                            width={18}
                            height={18}
                        />
                    ),
                },
            ],
        })
    }

    // if (canSeeMigration) {
    //     adminNavItems.push({
    //         key: 'admin',
    //         route: PRIVATE_ROUTES.storyMapMigration,
    //         label: 'Story Map Migration',
    //         icon: (
    //             <Icon
    //                 icon="mdi:database-arrow-right"
    //                 className={styles.icon}
    //                 width={20}
    //                 height={20}
    //             />
    //         ),
    //     })
    // }

    return [
        {
            key: 'home',
            route: PRIVATE_ROUTES.home,
            label: 'Home',
            icon: (
                <span className={styles.icon}>
                    <HomeSidebarIcon />
                </span>
            ),
        },
        ...adminNavItems,
    ]
}

export default SuperAdminRoutesNavigation
